import { InjectionToken, inject, type StaticProvider } from '@angular/core';

export const PARTNER_WEB_URL = new InjectionToken<string>('PARTNER_WEB_URL');

export function providePartnerWebUrl(partnerWebUrl: string): StaticProvider {
    return {
        provide: PARTNER_WEB_URL,
        useValue: partnerWebUrl,
    };
}

export function injectPartnerWebUrl(): string | null {
    return inject(PARTNER_WEB_URL);
}
